
const constants = require('../constants');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 */
// privated function in use related to displayMessageAndChangeIcon
function displayMessageAndChangeIcon(data, icon) {
    let status;
    let messageIcon;

    $.spinner().stop();

    if (data.success) {
        status = 'alert-success';
        messageIcon = '<span class="icon-checked-line"></span>';
        if (icon.hasClass('icon-favorites')) {
            icon.removeClass('icon-favorites').addClass('icon-favorites-on');
        }
    } else {
        status = 'alert-danger';
        messageIcon = '<span class="icon-alert"></span>';
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append('<div class="add-to-wishlist-messages "></div>');
    }
    $('.add-to-wishlist-messages').append(
        `<div class="add-to-wishlist-alert alert text-center ${status}">${messageIcon} ${data.msg}</div>`,
    );

    setTimeout(() => {
        $('.add-to-wishlist-messages').remove();
    }, constants.sfccAlertTime);
}

const addWishlistGrid = (target) => {
    const icon = target.find($('i'));
    const url = target.attr('href');
    const idContainer = target.closest('.product').find('.add-to-cartGrid, .add-to-cart-globalGrid, .add-to-cart-grid-marshall, .outofstock-button');
    if (idContainer.length) {
        const pid = idContainer.data('pid');
        let optionId = target
            .closest('.product-detail')
            .find('.product-option')
            .attr('data-option-id');
        let optionVal = target
            .closest('.product-detail')
            .find('.options-select option:selected')
            .attr('data-value-id');
        optionId = optionId || null;
        optionVal = optionVal || null;
        if (!url || !pid) {
            return;
        }

        $.spinner().start();
        $.ajax({
            url,
            type: 'post',
            dataType: 'json',
            data: {
                pid,
                optionId,
                optionVal,
            },
            success(data) {
                $.spinner().stop();

                displayMessageAndChangeIcon(data, icon);
            },
            error(err) {
                $.spinner().stop();

                displayMessageAndChangeIcon(err, icon);
            },
        });
    }
};

const addWishlistProdView = (target) => {
    const url = target.data('href');
    const button = target;

    let pid = target.closest('.product-detail').find('.product-id').html();
    if (pid) {
        pid = pid.trim();
    }
    let optionId = target.closest('.product-detail').find('.product-option').attr('data-option-id');
    let optionVal = target.closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
    optionId = optionId || null;
    optionVal = optionVal || null;

    if (!url || !pid) {
        return;
    }

    $.spinner().start();
    $(this).attr('disabled', true);
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {
            pid: pid,
            optionId: optionId,
            optionVal: optionVal,
        },
        success: (data) => {
            displayMessageAndChangeIcon(data, button);
        },
        error: (err) => {
            displayMessageAndChangeIcon(err, button);
        },
    });
};

module.exports = {
    addToWishlist() {
        $('body').on('click', '.wishlistTile, .add-to-wish-list', (e) => {
            e.preventDefault();
            const target = $(e.currentTarget);

            if (target.hasClass('wishlistTile')) {
                addWishlistGrid(target);
            } else {
                addWishlistProdView(target);
            }
        });
    },
};
